export const required = <T>(value: T | undefined, key: string): T => {
    if (value === undefined || value === null || value === '') {
        throw new Error(`Required env var missing: ${key}`);
    }
    return value;
};
